import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { District, User } from "../../../mp-database"
import { RootState } from "../../redux/store"
import { getDistrictById } from "../../../mp-database"
import { enqueueSnackbar } from "notistack"
import { useLeaveImpersonationManage } from "./useLeaveImpersonationManage"

// Hook for getting data for impersonation in impersonated user's account
// (this hook is used in `ImpersonationBannerContainer` for correct ui displaying)
export const useImpersonationBannerManage = (args: {
  isAuthed: boolean
  isNotUsed: boolean
}) => {
  const { isAuthed, isNotUsed } = args

  const [impersonatedUserDistrict, setImpersonatedUserDistrict] =
    useState<District>(null)
  const [impersonatedUserDistrictLoading, setImpersonatedUserDistrictLoading] =
    useState<boolean>(false)

  const { user } = useSelector((state: RootState) => ({
    user: state.users.testUser as User
  }))

  const {
    impersonationEnable,
    leaveImpersonationLoading,
    leaveImpersonationHandler
  } = useLeaveImpersonationManage()

  useEffect(() => {
    // Method for getting district data of impersonated user
    const getImpersonatedUserDistrict = async () => {
      if (
        !isAuthed ||
        isNotUsed ||
        !impersonationEnable ||
        !user?.schoolDistrict
      ) {
        return
      }

      try {
        setImpersonatedUserDistrictLoading(true)

        const district = await getDistrictById(user?.schoolDistrict)

        if (!district?.data) {
          return
        }

        setImpersonatedUserDistrict(district.data)
      } catch (error) {
        enqueueSnackbar(
          "An error occurred while trying to fetch user's district.",
          {
            variant: "error",
            autoHideDuration: 10000
          }
        )
      } finally {
        setImpersonatedUserDistrictLoading(false)
      }
    }

    getImpersonatedUserDistrict()
  }, [isAuthed, isNotUsed, impersonationEnable, user?.schoolDistrict])

  return {
    impersonationEnable: impersonationEnable,
    impersonatedUserName: user?.fullName,
    impersonatedUserDistrict,
    impersonatedUserDistrictLoading,
    leaveImpersonationLoading,
    leaveImpersonationHandler
  }
}
